import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Typography, Form, Switch, Row, Col, Icon, Tooltip } from 'antd'
import styled from "styled-components";

const { Text, Title } = Typography

const Styled = styled.div`
  .ant-tooltip-inner {
    color: #000000a6;
    background-color: white;
    width: auto;
    min-width: 290px;
    cursor: text;
  }
  .ant-tooltip-arrow::before {
    background-color: white;
  }
`;

class SwitchBox extends Component {
	state = {
	}
	render() {
		const { label, onChange, fontSize, inModal = false, textToolTip = "" } = this.props
		const { getFieldDecorator } = this.props.form;
		return (
			<>
				{

					inModal ?
						<Styled>
							<Row gutter={16} >
								<Col xs={{ span: 24 }}>
									<div className="card-custom-switch" >
										<Row gutter={16} >
											<Col span={20} align="start">
												<p className='meeting-management' style={{ fontSize: fontSize }}>{label + " "}
													<Tooltip placement="top" title={textToolTip} getPopupContainer={(triggerNode) => triggerNode}>
														<Icon
															style={{ cursor: 'pointer' }}
															type="info-circle"
														/>
													</Tooltip>
												</p>
											</Col>
											<Col span={4} align="end">
												<Switch onChange={onChange} />
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</Styled>
						:
						<Styled>
							<Row gutter={16} className={'py-4'}>
								<Col xs={{ span: 20, offset: 2 }} lg={{ span: 16, offset: 4 }}>
									<div className="card-custom-switch" >
										<Row gutter={16} >
											<Col span={18} align="start">
												<p className='meeting-management' style={{ fontSize: fontSize }}>{label + " "}
													<Tooltip placement="top" title={textToolTip} getPopupContainer={(triggerNode) => triggerNode}>
														<Icon
															style={{ cursor: 'pointer' }}
															type="info-circle"
														/>
													</Tooltip>
												</p>
											</Col>
											<Col span={6} align="end" style={{ display: 'flex', justifyContent: 'flex-end' }}>
												<Switch onChange={onChange} />
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</Styled>
				}
			</>
		)
	}
}


SwitchBox.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedSwitchBox = Form.create()(SwitchBox)

export default withApollo(WrappedSwitchBox)